//验证只能是数字
export let isLegNull = function (rule, value, callback) {
  if (value.length == 0) {
    callback();
  }
  if (!(/^[0-9]*$/g.test(value))) {
    callback(new Error('请填写数字!'));
  } else {
    //否则成功回调
    callback();
  }
}

//验证路径格式
export let thePath = function (rule, value, callback) {
  if (/^([A-Za-z]{1}):\\[a-zA-Z0-9\\]+$/.test(value)) {
    //否则成功回调
    callback();
  } else {
    callback(new Error('请输入正确路径'));
  }
};

//验证空格
export let validateSpace = (rule, value, callback) => {
  if (/^ +| +$/g.test(value)) {
    callback(new Error('不能输入空格'));
  } else {
    //否则成功回调
    callback();
  }
};

//验证密码ß
export let validatePassword = (rule, value, callback) => {
  if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]/.test(value) && value.length >= 6 && value.length <= 12) {
    callback()
  } else {
    callback(new Error('密码需包含字母和数字，且6 - 12位!'))
  }
};

//验证邮箱
export let validatorEmail = (rule, value, callback) => {
  if (/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(value)) {
    callback();
  } else {
    callback(new Error('请输入正确邮箱'));
  }
};

//验证手机号
export let validatorPhone = (rule, value, callback) => {
  if (/^[1][3,4,5,7,8][0-9]{9}$/.test(value)) {
    callback();
  } else {
    callback(new Error('请输入正确手机号'));
  }
};

//只能是数字或字母
export let validateLetterNumber = (rule, value, callback) => {
  if (!(/^[A-Za-z0-9]+$/.test(value))) {
    callback(new Error('只能是数字或字母'));
  } else {
    //否则成功回调
    callback();
  }
};

//验证IP
export let validateIP = (rule, value, callback) => {
  if ("^(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|[1-9])\\." + "(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)\\." + "(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)\\." + "(1\\d{2}|2[0-4]\\d|25[0-5]|[1-9]\\d|\\d)$".test(value)) {
    callback(new Error('请输入正确的IP地址'));
  } else {
    //否则成功回调
    callback();
  }
};
 /*-------------注册页验证-----------------------*/
 // 姓名不能为空
export  let validateName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('姓名不能为空'));
  }else {
    callback();
  }
};
 // 公司不能为空
export let validateCompany = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('公司不能为空'));
  }else {
    callback();
  }
};
// 验证手机号码
export  let validatePhone = (rule, value, callback) => {
    if (!value) {
      return callback(new Error('手机号码不能为空'));
    }
    validatorPhone(rule, value, callback);
  }; 
// 验证验证码
export  let validateCode = (rule, value, callback) => {
    if (!value) {
      return callback(new Error('验证码不能为空'));
    }else {
      callback();
    }
    
  };

